function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 29,
  fill: "#d8d9d8",
  r: 29
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5296 43c2.1455-.3048 4.0263-2.544 5.2098-5.851-1.7109-.3832-3.4568-.5888-5.2098-.6133z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m32.9572 42.4741c.1269-.0367.2532-.0737.3786-.1143.1057-.034.21-.0708.3143-.1072.1234-.0426.2463-.0865.3687-.133.1043-.0397.2077-.0818.3112-.1239.1195-.0502.2387-.1001.3567-.1503.1031-.0453.2055-.0928.3078-.1405.1158-.0546.2311-.1102.3455-.168.1003-.0512.2005-.1033.3009-.1569.1123-.0603.224-.1217.3349-.1849.1004-.0568.1971-.1138.2948-.1726.1087-.0668.2169-.1337.3244-.2005.0962-.0612.1922-.1234.2869-.1875.1058-.0713.2101-.1455.3139-.2197.0933-.0668.186-.1334.2771-.2005.1004-.0773.2032-.1574.3039-.2377.0893-.0713.1784-.142.2663-.2152.1002-.0833.1961-.1694.2933-.2556.0852-.0757.1709-.1506.2542-.2282.0957-.0894.189-.1819.2823-.2737.0808-.0798.1625-.1584.2416-.2402.0147-.0152.0287-.0316.0438-.0473-1.0936-.5648-2.2455-1.0082-3.4357-1.3221-.6189 1.9739-1.7204 3.7626-3.2046 5.2037.0407-.0105.0813-.0191.1219-.0296.1073-.0301.2126-.0632.3173-.0943z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m43.0564 29.5014h-6.0122c-.0227 2.3475-.3633 4.681-1.0124 6.9371 1.3236.3535 2.6009.8618 3.8055 1.5143 1.9778-2.3837 3.1099-5.3557 3.2191-8.4514z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5296 28.4986h6.5118c-.0255-2.2645-.3577-4.515-.9872-6.6903-1.8132.4135-3.6651.6343-5.5246.6588z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5296 15v6.4643c1.753-.0247 3.4989-.2301 5.2098-.6133-1.1835-3.3069-3.0643-5.5462-5.2098-5.851z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5296 35.5329c1.8595.0247 3.7114.2455 5.5246.6591.6295-2.1754.9617-4.4261.9872-6.6906h-6.5118z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m39.8373 20.0472c-1.2046.6525-2.4819 1.1608-3.8055 1.5143.6491 2.2561.9897 4.5896 1.0124 6.9371h6.0122c-.1095-3.0954-1.2416-6.0675-3.2191-8.4514z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m39.1598 19.2866c-.0147-.015-.0286-.0311-.0431-.0466-.0793-.0817-.1615-.1606-.2423-.2401-.0931-.0919-.1859-.1846-.2818-.2738-.083-.0773-.169-.1505-.2542-.2277-.0972-.0861-.1944-.1731-.2943-.2563-.0866-.0732-.1755-.1432-.2637-.2135-.1003-.0813-.2032-.1621-.3065-.2397-.0906-.0683-.1824-.1344-.2747-.2005-.1048-.0754-.2101-.1506-.3168-.2223-.0938-.0632-.189-.1249-.2843-.1854-.1084-.0697-.2166-.138-.3271-.2041-.0967-.0581-.1944-.1154-.2923-.1709-.1121-.0642-.2245-.1264-.3379-.1871-.1003-.0502-.2005-.1048-.3009-.155-.1153-.0582-.2316-.1143-.3508-.1694-.1004-.0477-.2022-.0942-.3056-.1395-.1187-.0527-.2387-.1002-.3584-.1504-.1033-.0421-.2061-.0837-.3104-.1234-.1217-.0465-.2451-.0901-.3685-.1327-.1043-.0367-.2086-.0732-.3144-.1074-.1253-.0407-.2507-.0777-.3795-.1149-.1043-.0306-.2091-.0617-.3146-.0896-.0404-.011-.0815-.0196-.1222-.0301 1.4842 1.4411 2.5855 3.2296 3.2047 5.2037 1.1913-.3139 2.345-.7575 3.4396-1.3233z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m15 28.4986h6.0121c.0228-2.3475.3633-4.681 1.0121-6.9371-1.3233-.3533-2.6006-.8616-3.8051-1.5143-1.9778 2.3837-3.1099 5.356-3.2191 8.4514z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5268 43v-6.4643c-1.753.0247-3.4989.2301-5.2098.6133 1.1832 3.307 3.0643 5.5462 5.2098 5.851z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5267 29.5014h-6.5118c.0255 2.2645.3575 4.5152.9872 6.6906 1.8132-.4138 3.6649-.6346 5.5246-.6591z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5268 15c-2.1455.3048-4.0266 2.5441-5.2098 5.851 1.7109.3834 3.4568.5888 5.2098.6133z",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5267 22.4671c-1.8595-.0245-3.7114-.2453-5.5246-.6588-.6297 2.1753-.9617 4.4258-.9872 6.6903h6.5118z",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m25.5368 15.4057c-.0406.0105-.0812.0191-.1219.0296-.1062.0284-.211.06-.3168.0906-.1258.0367-.2507.0737-.377.1138-.1065.0346-.2113.0713-.3161.1078-.1227.0433-.2456.0864-.367.1324-.1048.0402-.2081.0818-.3119.1244-.1193.0502-.2388.1004-.3565.1503-.1033.0453-.2054.0928-.3078.1405-.1158.0546-.2311.1102-.3454.168-.1004.0512-.2008.1036-.3009.1569-.1124.0603-.2238.122-.3345.1851-.1004.0561-.199.1136-.2957.1724-.109.0656-.2167.1334-.3239.2005-.0965.0617-.1922.1239-.287.188-.1058.0713-.21.1455-.3139.2197-.0932.0668-.186.1334-.2774.2007-.1025.0771-.2005.1574-.3038.2375-.0891.0713-.179.142-.2661.2157-.1004.0828-.1956.1685-.2924.2541-.0856.0764-.1721.1506-.2558.2297-.0952.0889-.188.1812-.2811.2727-.0808.0799-.163.1587-.2424.2407-.0144.0152-.0284.0318-.0435.0473 1.0934.565 2.2456 1.0084 3.4357 1.3223.6189-1.9729 1.7197-3.7604 3.2031-5.2007z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m19.1817 39.0002c.0933.0918.1861.1846.2819.274.0832.0771.1689.1503.2543.2274.0972.0864.1944.1731.2943.2564.0867.0727.1751.1429.2637.2135.1004.0812.2005.162.3068.2401.0903.0679.1821.1335.2739.2008.1048.0752.2106.1503.3173.2226.0938.0631.1891.1248.2843.1855.1085.0696.2167.1379.3271.204.0967.0583.1944.1153.2923.1711.1122.0642.2245.1264.3379.1868.1001.0502.2005.1048.3009.155.1153.0583.2316.1143.3508.1697.1004.0472.2023.0938.3056.1393.1187.0526.2385.1001.3584.1503.1033.0421.2062.0838.3105.1234.1217.0468.245.0904.3684.133.1043.0364.2086.0732.3144.1072.1254.0406.2507.0779.3795.1148.1043.0306.2091.0617.3144.0899.0406.011.0817.0196.1224.0301-1.4842-1.4413-2.5855-3.2299-3.2046-5.2039-1.1902.3141-2.3423.7575-3.4358 1.3228.0147.0149.0287.0311.0434.0465.0751.0813.1562.1601.2379.2397z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m18.2191 37.9528c1.2045-.6525 2.4818-1.1608 3.8051-1.5143-.6488-2.2561-.9893-4.5896-1.0121-6.9371h-6.0121c.1094 3.0954 1.2413 6.0674 3.2191 8.4514z",
  fill: "#fff"
});

var SvgSite = function SvgSite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 58 58",
    width: 58,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/site.7bdc341f.svg";
export { ForwardRef as ReactComponent };